import * as React from 'react';
import { compose, pure, withHandlers } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import Input from '@material-ui/core/Input';
import Select from 'react-select';
import { toCssValue, transition } from '@topconagriculture/theme';
import { Text } from '../../Text';
import CreatableSelect from 'react-select/lib/Creatable';
import cn from 'classnames';
const styles = (theme) => createStyles({
    container: {},
    root: {
        width: '100%',
        height: 'calc(1em + 8px)',
        paddingBottom: 3,
        transition: transition(50),
    },
    label: {
        minWidth: 100,
        fontSize: theme.font.size.mediumSmall,
        color: theme.color.grey.dark,
        lineHeight: 1.35,
    },
    field: {
        padding: toCssValue([2, 0, 1]),
        width: '100%',
    },
});
const makeSelectTheme = (theme, props) => ({
    control: (base) => ({
        ...base,
        borderStyle: 'none',
        borderWidth: 0,
        borderColor: 'transparent !important',
        backgroundColor: 'transparent !important',
        boxShadow: 'none !important',
        minHeight: 27,
        padding: 0,
        cursor: 'text',
    }),
    valueContainer: (base) => ({
        ...base,
        color: `${theme.color.font.dark} !important`,
        padding: 0,
    }),
    dropdownIndicator: (base) => ({
        ...base,
        color: `${theme.color.font.dark} !important`,
        padding: toCssValue([1, 0]),
        cursor: 'pointer',
    }),
    indicatorSeparator: (base) => ({
        ...base,
        background: 'transparent',
    }),
    placeholder: (base) => ({
        ...base,
        color: theme.color.input.placeholder,
        margin: 0,
    }),
    menu: (base) => ({
        ...base,
        marginTop: base.marginTop - 5,
        zIndex: 150,
        top: 'auto',
    }),
    menuList: (base) => ({
        ...base,
        paddingTop: 7,
        paddingBottom: 7,
    }),
    option: (base, state) => ({
        ...base,
        cursor: 'pointer',
        background: state.isSelected
            ? `${theme.color.grey.light} !important`
            : `${state.isFocused ? theme.color.grey.lightest : theme.color.background.light} !important`,
        fontWeight: state.isFocused ? theme.font.weight.bold : theme.font.weight.normal,
        color: theme.color.font.dark,
        padding: theme.space.padding.small + theme.space.padding.small / 2,
    }),
});
export const SelectWrapped = (props) => {
    const { classes, notFoundText, theme, internalValue, customOption, canCreateOptions, disabled, testId = 'Select', ...other } = props;
    const customOptionEl = customOption ? { Option: customOption } : null;
    return canCreateOptions ? (React.createElement(CreatableSelect, Object.assign({}, other, { isDisabled: disabled, components: customOptionEl, styles: makeSelectTheme(theme, props), className: classes.field, "data-testid": `${testId}`, value: internalValue, formatCreateLabel: (s) => `Add ${s}` }))) : (React.createElement(Select, Object.assign({}, other, { isDisabled: disabled, "data-testid": `${testId}`, components: customOptionEl, styles: makeSelectTheme(theme, props), className: classes.field, value: internalValue, noOptionsMessage: () => React.createElement(Text, null, notFoundText || 'Not Found') })));
};
const AutocompleteSelect = (props) => {
    const { classes, className, handleChange, input, placeholder, defaultValue, label, meta, theme, listData, dropdownPosition, canCreateOptions, customOption, disabled, name = 'AutocompleteSelect', id = 'AutocompleteSelect', testId = 'AutocompleteSelect', notFoundText, value, onInputChange, } = props;
    console.warn('---- TAP DEV TEAM ----');
    console.warn('This component has been deprecated. Please use new AutocompleteSelectInput instead.');
    console.warn('--------');
    const findItemForValue = (val) => listData.find((x) => x.value === val);
    const createItem = (val) => ({ label: value, value: val });
    let iValue;
    if (value) {
        iValue = findItemForValue(value) || createItem(value);
    }
    else if (input && input.value) {
        iValue = findItemForValue(input.value) || createItem(input.value);
    }
    let dValue;
    if (defaultValue) {
        if (typeof defaultValue === 'string') {
            dValue = findItemForValue(defaultValue) || createItem(defaultValue);
        }
        else {
            dValue = defaultValue;
        }
    }
    else if (input && input.defaultValue) {
        dValue = findItemForValue(input.defaultValue);
    }
    const inputProps = {
        classes,
        instanceId: id,
        name,
        simpleValue: false,
        options: listData,
        disabled,
        customOption,
        canCreateOptions,
        notFoundText: notFoundText,
        className,
        onInputChange,
        internalValue: iValue || dValue || null,
        theme,
        menuPosition: dropdownPosition || 'fixed',
        maxMenuHeight: 250,
    };
    const labelEl = (React.createElement(Text, { "data-testid": `${testId}-label`, block: true, size: theme.font.size.mediumSmall, lineHeight: theme.font.lineHeight.medium }, label));
    const errorEl = meta && meta.error && meta.dirty && (React.createElement(Text, { block: true, "data-testid": `${testId}-error`, size: theme.font.size.mediumSmall, lineHeight: theme.font.lineHeight.mediumBig, color: theme.color.error.main }, meta.error));
    return (React.createElement("div", { className: cn(classes.container, className), "data-testid": `${testId}` },
        label && labelEl,
        React.createElement(Input, { name: name, value: input.value, "data-testid": `${testId}-input`, fullWidth: true, inputComponent: SelectWrapped, onChange: handleChange, placeholder: placeholder, id: "react-select-single", inputProps: inputProps, error: meta && meta.invalid && meta.touched }),
        errorEl));
};
const ComposedAutocompleteSelect = compose(withStyles(styles, { withTheme: true }), pure, withHandlers({
    handleChange: (props) => (item) => {
        const onChange = props.onChange || props.input.onChange;
        return onChange && onChange((item && item.value) || null);
    },
}))(AutocompleteSelect);
ComposedAutocompleteSelect.displayName = 'AutocompleteSelect';
export default ComposedAutocompleteSelect;
//# sourceMappingURL=AutocompleteSelect.js.map